'use strict';

// The editor creator to use.
import ClassicEditorBase from '@ckeditor/ckeditor5-editor-classic/src/classiceditor';
import DecoupledBase from '@ckeditor/ckeditor5-editor-decoupled/src/decouplededitor';

import EssentialsPlugin from '@ckeditor/ckeditor5-essentials/src/essentials';
import AutoformatPlugin from '@ckeditor/ckeditor5-autoformat/src/autoformat';
import BoldPlugin from '@ckeditor/ckeditor5-basic-styles/src/bold';
import ItalicPlugin from '@ckeditor/ckeditor5-basic-styles/src/italic';
import HeadingPlugin from '@ckeditor/ckeditor5-heading/src/heading';
import LinkPlugin from '@ckeditor/ckeditor5-link/src/link';
import ListPlugin from '@ckeditor/ckeditor5-list/src/list';
import ParagraphPlugin from '@ckeditor/ckeditor5-paragraph/src/paragraph';
import FontPlugin from '@ckeditor/ckeditor5-font/src/font';
import PasteFromOfficePlugin from '@ckeditor/ckeditor5-paste-from-office/src/pastefromoffice';
import HorizontalLinePlugin from '@ckeditor/ckeditor5-horizontal-line/src/horizontalline';
import IndentPlugin from '@ckeditor/ckeditor5-indent/src/indent';
import IndentBlockPlugin from '@ckeditor/ckeditor5-indent/src/indentblock';
import AlignmentPlugin from '@ckeditor/ckeditor5-alignment/src/alignment';
import MentionPlugin from '@ckeditor/ckeditor5-mention/src/mention';

class MailEditor extends ClassicEditorBase {}
class DecoupledMailEditor extends DecoupledBase {}

// Plugins to include in the build.
const plugins = [
  EssentialsPlugin,
  PasteFromOfficePlugin,
  HeadingPlugin,
  ParagraphPlugin,
  BoldPlugin,
  ItalicPlugin,
  AlignmentPlugin,
  ListPlugin,
];

// Editor configuration.
const config = {
  // This value must be kept in sync with the language defined in webpack.config.js.
  language: 'en',
};

/* ###############################
MAIL EDITOR - START
############################### */

const mailPlugins = [AutoformatPlugin, LinkPlugin, FontPlugin, IndentPlugin, IndentBlockPlugin, HorizontalLinePlugin, MentionPlugin].concat(
  plugins
);
const mailConfig = {
  ...config,
  toolbar: [
    'heading',
    '|',
    'bold',
    'italic',
    'fontBackgroundColor',
    'fontColor',
    '|',
    'alignment:left',
    'alignment:center',
    'alignment:right',
    '|',
    'bulletedList',
    'numberedList',
    'horizontalLine',
    'link',
    '|',
    'outdent',
    'indent',
    '|',
    'undo',
    'redo',
  ],
  heading: {
    options: [
      { model: 'paragraph', title: 'Paragraph', class: 'ck-heading_paragraph' },
      { model: 'heading1', view: 'h1', title: 'Heading 1', class: 'ck-heading_heading1' },
      { model: 'heading2', view: 'h2', title: 'Heading 2', class: 'ck-heading_heading2' },
      { model: 'heading3', view: 'h3', title: 'Heading 3', class: 'ck-heading_heading3' },
    ],
  },
  alignment: {
    options: ['left', 'center', 'right'],
  },
  fontColor: {
    colors: [
      {
        color: 'rgba(0, 0, 0, 0.87)',
        label: 'Black',
      },
      {
        color: '#4C4C4C',
        label: 'Dim grey',
      },
      {
        color: '#999999',
        label: 'Grey',
      },
      {
        color: '#E5E5E5',
        label: 'Light grey',
      },
      {
        color: '#E54C4C',
        label: 'Red',
      },
    ],
    columns: 6,
    documentColors: 12,
  },
  fontBackgroundColor: {
    colors: [
      {
        color: '#E54C4C',
        label: 'Red',
      },
      {
        color: '#E5994C',
        label: 'Orange',
      },
      {
        color: '#E5E54C',
        label: 'Yellow',
      },
      {
        color: '#99E54C',
        label: 'Light green',
      },
      {
        color: '#4CE54C',
        label: 'Green',
      },
    ],
    columns: 6,
    documentColors: 12,
  },
};

MailEditor.builtinPlugins = mailPlugins;
MailEditor.defaultConfig = mailConfig;

DecoupledMailEditor.builtinPlugins = mailPlugins;
DecoupledMailEditor.defaultConfig = mailConfig;

/* ###############################
MAIL EDITOR - END
############################### */

export default {
  MailEditor,
  DecoupledMailEditor,
};
